import PageManager from './page-manager';

export default class Page extends PageManager {
    loaded() {
        $('.stores-section [data-fancybox="images"]').each((index, item) => {
            $(item).attr('data-lightbox', 'store-image')
        })
    }
}



// WEBPACK FOOTER //
// ./assets/js/theme/page.js